import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 1,
  class: "gaokao-download-disabled"
}
const _hoisted_5 = {
  key: 0,
  class: "gaokao-pagination"
}

import { ref, watch } from "vue";
import { message } from "ant-design-vue";
import { getGaokaoPaperDownloadApi } from "@/servers/api/papers";


export default /*@__PURE__*/_defineComponent({
  __name: 'GaokaoDrawer',
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const subjects = ["语文", "数学", "英语", "物理", "化学", "生物", "历史", "地理", "政治"];
const activeSubject = ref("语文");
const papers = ref<API.GaokaoPaperDownload[]>([]);
const total = ref(0);
const loading = ref(false);
const pagination = ref({ page: 1, size: 10 });

const loadPapers = async (page = 1) => {
  loading.value = true;
  try {
    const res = await getGaokaoPaperDownloadApi({
      subject: activeSubject.value,
      page,
      size: pagination.value.size,
    });
    papers.value = Array.isArray(res?.data) ? res.data : [];
    total.value = Number(res?.total ?? papers.value.length);
    pagination.value.page = page;
  } catch {
    papers.value = [];
    total.value = 0;
    message.error("加载试卷失败");
  } finally {
    loading.value = false;
  }
};

const handleSubjectChange = () => {
  loadPapers(1);
};

const handlePageChange = (page: number) => {
  loadPapers(page);
};

watch(
  () => props.open,
  (val) => {
    if (val) {
      activeSubject.value = "语文";
      loadPapers(1);
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    open: __props.open,
    title: "高考试卷",
    placement: "right",
    width: 520,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('update:open', false)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_tabs, {
        activeKey: activeSubject.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeSubject).value = $event)),
        onChange: handleSubjectChange
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(subjects, (s) => {
            return _createVNode(_component_a_tab_pane, {
              key: s,
              tab: s
            }, null, 8, ["tab"])
          }), 64))
        ]),
        _: 1
      }, 8, ["activeKey"]),
      _createVNode(_component_a_spin, { spinning: loading.value }, {
        default: _withCtx(() => [
          (!loading.value && papers.value.length === 0)
            ? (_openBlock(), _createBlock(_component_a_empty, {
                key: 0,
                description: "暂无试卷"
              }))
            : (_openBlock(), _createBlock(_component_a_list, {
                key: 1,
                "data-source": papers.value,
                split: true
              }, {
                renderItem: _withCtx(({ item }) => [
                  _createVNode(_component_a_list_item, null, {
                    actions: _withCtx(() => [
                      (item.download_url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: item.download_url,
                            target: "_blank",
                            rel: "noopener",
                            class: "gaokao-download-link"
                          }, "下载", 8, _hoisted_3))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, "暂无下载地址"))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_list_item_meta, null, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        description: _withCtx(() => [
                          (item.year)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.year), 1))
                            : _createCommentVNode("", true),
                          (item.year && item.subject)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, " · "))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(item.subject), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["data-source"]))
        ]),
        _: 1
      }, 8, ["spinning"]),
      (total.value > pagination.value.size)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_a_pagination, {
              size: "small",
              current: pagination.value.page,
              "page-size": pagination.value.size,
              total: total.value,
              "show-total": (t) => `共 ${t} 份`,
              onChange: handlePageChange
            }, null, 8, ["current", "page-size", "total", "show-total"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})